import React, { useContext } from 'react';
import classNames from 'classnames';
import ResolveHeader from 'components/ResolveHeader';
import { SmallFooter } from 'components/SmallFooter';
import EnterpriseHeader from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/components/EnterpriseHeader';
import { Navigate, Outlet } from 'react-router-dom';
import useRegularMemberHomeRedirect from 'hooks/useRegularMemberHomeRedirect';
import EnterpriseProvider from './providers/Enterprise/Enterprise.provider';
import EnterpriseContext from './providers/Enterprise/Enterprise.context';
import RwcEnterpriseNavigation from './components/RwcEnterpriseNavigation';
import DownloadStatusProvider from 'providers/DownloadStatus';
import ExportUsageReportModal from 'router/subrouters/Dash/subrouters/private/subrouters/Enterprise/pages/Analytics/components/ExportUsageReportModal';

import './RwcAnalytics.styles.scss';
import './RwcAnalytics.styles.responsive.scss';

const EnterpriseWrapper: React.FC = () => {
  const { enterprise } = useContext(EnterpriseContext);

  // Plain members can only see RWC suggested actions; keep them out of the
  // overview, configuration and branding subroutes even via a typed URL.
  const homeRedirect = useRegularMemberHomeRedirect(enterprise, true);

  if (homeRedirect) return <Navigate to={homeRedirect} replace />;

  return (
    <>
      <EnterpriseHeader enterprise={enterprise} />

      <div className="rwc-analytics__navigation-row">
        <RwcEnterpriseNavigation />
        <ExportUsageReportModal enterprise={enterprise} />
      </div>

      <Outlet />
    </>
  );
};

type RwcAnalyticsProps = {
  className?: string;
};

const RwcAnalytics: React.FC<RwcAnalyticsProps> = (props) => {
  const { className } = props;

  const classes = classNames('rwc-analytics', className);

  return (
    <DownloadStatusProvider>
      <EnterpriseProvider>
        <div className={classes}>
          <ResolveHeader />

          <main>
            <EnterpriseWrapper />
          </main>

          <SmallFooter />
        </div>
      </EnterpriseProvider>
    </DownloadStatusProvider>
  );
};

export default RwcAnalytics;
